import React from 'react';
import styled, { css } from 'styled-components';

import { Switch, Box, BoxProps, SwitchProps } from '@mui/material';
import { conditionApply } from '@trader/utils';
import { ICommonStyledProps } from '@trader/types';

import { ContainerControlInfo } from '../controlInfo/styled';

const opacity = 0.3;

export const Switcher = styled((props: SwitchProps) => (
  <Switch focusVisibleClassName='.Mui-focusVisible' disableRipple {...props} />
))`
  ${({ theme }) => css`
    '& .MuiSwitch-switchBase': {
      padding: 0;
      margin: 2px;
      transition-duration: 0.3s;
      '&.Mui-checked': {
        transform: translateX(10px);
        color: ${theme.palette.common.white};
        '& + .MuiSwitch-track': {
          background: ${theme.palette.green.main};
          opacity: 1;
          border: 0;
        },
        '&.Mui-disabled + .MuiSwitch-track': {
          opacity: 0.5;
        },
      },
      '&.Mui-focusVisible .MuiSwitch-thumb': {
        color: ${theme.palette.green.main};
        border: 6px solid ${theme.palette.common.white};
      },
      '&.Mui-disabled .MuiSwitch-thumb': {
        color: ${theme.palette.grey[100]};
        '&.Mui-disabled + .MuiSwitch-track': {
          opacity: 0.3;
        },
      },
      '& .MuiSwitch-thumb': {
        box-sizing: border-box;
        width: 16px;
        height: 16px;
      },
      '& .MuiSwitch-track': {
        border-radius: 5px;
        background: ${theme.palette.grey[500]};
        opacity: 1;
        transition: ${theme.transitions.create(['background-color'], {
          duration: 500,
        })};
      },
    }
  `}
`;

interface IContainerProps extends BoxProps, ICommonStyledProps {
  checked?: boolean;
  className?: string;
  children?: React.ReactNode;
}

export const Container = styled<React.FC<IContainerProps>>(
  ({ checked, $isDisabled, $isError, ...rest }) => <Box {...rest} />
)`
  ${({ checked, $isDisabled, $isError, theme }) =>
    css`
      ${Switcher} {
        margin-right: 10px;
        ${conditionApply(
          [$isError],
          `
          .MuiSwitch-switchBase {
            color: ${theme.palette.error.main};
          }
          .MuiSwitch-track {
            background-color: ${theme.palette.error.main};
          }
        `
        )}
        ${conditionApply(
          [$isDisabled],
          `
          .MuiSwitch-switchBase {
              color: ${theme.palette.grey['300']};
          }
        `
        )}
        ${conditionApply(
          [checked && $isDisabled],
          `
          .MuiSwitch-switchBase {
            color: ${theme.palette.primary.main};
            opacity: ${$isDisabled ? opacity : 1};
          }
        `
        )}
      }

      ${ContainerControlInfo} {
        margin-left: 15px;
        margin-top: -9px;
      }
    `}
`;

export const LeftLabel = styled('span')`
  ${() => css`
    font-size: 16px;
    font-weight: 400;
  `}
`;
